import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  listFeeds, addFeed, deleteFeed, refreshFeed, listFeedItems, importFeedItem,
} from '../services/feedsApi'

export function useFeeds() {
  return useQuery({ queryKey: ['feeds'], queryFn: listFeeds, staleTime: 60 * 1000 })
}

export function useFeedItems(feedId, limit = 100) {
  return useQuery({
    queryKey: ['feeds', 'items', feedId, limit],
    queryFn: () => listFeedItems({ feedId, limit }),
    enabled: !!feedId,
  })
}

function useFeedMutation(mutationFn) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['feeds'] }),
  })
}

export const useAddFeed = () => useFeedMutation(addFeed)
export const useDeleteFeed = () => useFeedMutation(deleteFeed)
export const useRefreshFeed = () => useFeedMutation(refreshFeed)

export function useImportFeedItem() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: importFeedItem,
    onSuccess: (_d, vars) => {
      qc.invalidateQueries({ queryKey: ['feeds'] })
      qc.invalidateQueries({ queryKey: ['rag', 'documents', vars.project] })
    },
  })
}
